<template>
  <ais-clear-refinements v-slot="{ refine }">

      <button
        class="ais-ClearRefinements-button"
        @click="resetFilters(refine)"
      >
        {{ $t('Clear filters') }}
      </button>


  </ais-clear-refinements>
</template>

<script lang="ts">

import { AisClearRefinements } from 'vue-instantsearch/vue3/es';

import { EVENT_SOURCE } from '~~/constants/googleTagManager';

export default defineComponent({
  name: 'ClearRefinements',
  components: {
    AisClearRefinements,
  },
  setup() {

    const route = useRoute();
    const { trackClearAllFilters } = useGtmEvents();
    const { getCurrentPageType } = usePageEventLocation();
    const {
      getters: {
        currentCategoryName,
      },
    } = useCategories();
    const pageType = getCurrentPageType();
    const isCategoryListingPage = pageType === EVENT_SOURCE.CATEGORY_LISTING;
    const categoryName = isCategoryListingPage ? currentCategoryName.value : '';
    const categoryPath = isCategoryListingPage ? route.params.slug : '';

    const resetFilters = (refine: () => void) => {

      trackClearAllFilters({
        categoryPath,
        categoryName,
        listingType: pageType,
      });
      refine();

    };

    return {
      resetFilters,
    };

  },
});

</script>
<style lang="scss">
@use "~/assets/scss/typesense/_ais-ClearRefinements" as ais-ClearRefinements;
</style>
